import { isDefined } from '@freelancer/utils';
import {
  ServiceOfferingShopCategoryServicePriceTypeApi,
  type ServiceOfferingShopCategoryServiceApi,
} from 'api-typings/service_offerings/service_offerings';
import { transformServiceOfferingDiscountDetails } from '../service-offerings/service-offerings.transformers';
import type { ServiceOfferingShopCategoryService } from './service-offering-shop-category-services.model';
import { ServiceOfferingShopCategoryServicePriceType } from './service-offering-shop-category-services.model';

export function transformServiceOfferingShopCategoryService(
  serviceOfferingShopCategoryService: ServiceOfferingShopCategoryServiceApi,
): ServiceOfferingShopCategoryService {
  return {
    id: serviceOfferingShopCategoryService.id,
    serviceOfferingId: serviceOfferingShopCategoryService.service_offering_id,
    categoryId: serviceOfferingShopCategoryService.category_id,
    title: serviceOfferingShopCategoryService.title,
    seoUrl: serviceOfferingShopCategoryService.seo_url,
    heroImageUuid: serviceOfferingShopCategoryService.hero_image_uuid,
    heroImageUrl: serviceOfferingShopCategoryService.hero_image_url,
    duration: serviceOfferingShopCategoryService.duration,
    price: serviceOfferingShopCategoryService.price,
    priceType: transformServiceOfferingShopCategoryServicePriceType(
      serviceOfferingShopCategoryService.price_type,
    ),
    shopId: serviceOfferingShopCategoryService.shop_id,
    discountDetails: isDefined(
      serviceOfferingShopCategoryService.discount_details,
    )
      ? transformServiceOfferingDiscountDetails(
          serviceOfferingShopCategoryService.discount_details,
        )
      : undefined,
  };
}

export function transformServiceOfferingShopCategoryServicePriceType(
  priceType: ServiceOfferingShopCategoryServicePriceTypeApi | undefined,
): ServiceOfferingShopCategoryServicePriceType | undefined {
  switch (priceType) {
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_ONLY_MONTHLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_ONLY_MONTHLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_ONLY_ANNUALLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_ONLY_ANNUALLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_ONLY_WEEKLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_ONLY_WEEKLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_MONTHLY_AND_HOURLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_MONTHLY_AND_HOURLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_ANNUALLY_AND_HOURLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_ANNUALLY_AND_HOURLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.SUBSCRIPTION_WEEKLY_AND_HOURLY:
      return ServiceOfferingShopCategoryServicePriceType.SUBSCRIPTION_WEEKLY_AND_HOURLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.HOURLY_ONLY:
      return ServiceOfferingShopCategoryServicePriceType.HOURLY_ONLY;
    case ServiceOfferingShopCategoryServicePriceTypeApi.HAS_FIXED_ITEMS:
      return ServiceOfferingShopCategoryServicePriceType.HAS_FIXED_ITEMS;
    default:
      return undefined;
  }
}
